import React from 'react'
import _ from 'lodash'
import { is, List, Map, Stack } from 'immutable'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Clipboard, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import * as ProductActions from 'x/modules/product/ProductState'
import { getStoreSelected, getSelectedProduct } from 'x/redux/selectors'
import * as NavActions from 'x/utils/navigation'
import * as api from 'x/utils/api'
import p from 'x/config/platform-specific'

import {
  IProductVariantSettingProps,
  IProductVariantSettingState,
  IProductVariantSettingViewNavParams,
  IEditProductResponse,
} from 'x/index'

import XText from 'xui/components/XText'
import XCard from 'xui/components/XCard'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import MkpLogo from 'xui/components/MkpLogo'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCustomHeader from 'xui/components/XCustomHeader'
import XImage from 'xui/components/XImage'
import Box from 'xui/components/Box'
import XButton from 'xui/components/XButton'
import XIcon from 'xui/components/XIcon'
import XSellyLogo from 'xui/components/XSellyLogo'
import XInput from 'xui/components/XInput'
import XNumericInput from 'xui/components/XNumericInput'
import HelpButton from 'xui/components/HelpButton'
import XSpinner from 'xui/components/XSpinner'
import ForwardIcon from 'xui/components/ForwardIcon'
import WarehousePicker, { WarehousePickerBase } from 'xui/components/product/WarehousePicker'
import XSwitch from 'xui/components/XSwitch'
import ProductBundleContainer from 'xui/components/ProductBundleContainer'

class ProductVariantSettingView extends React.Component<IProductVariantSettingProps, IProductVariantSettingState> {
  static displayName = 'ProductVariantSettingView'

  inProcess?: boolean

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: false,
      isSubmitting: false,
      selectedProduct: null,

      isAllowNegativeStock: false,
    }
  }

  async componentDidMount() {
    await this._initialize()
  }

  _initialize = async () => {
    const { selectedStore } = this.props
    const selectedProduct = util.getNavParam<IProductVariantSettingViewNavParams>(this.props, 'selectedProduct')

    const isAllowNegativeStock = selectedProduct?.v[0]?.allow_negative_stock || false
    await util.setStatePromise(this, { isInitialized: true, selectedProduct, isAllowNegativeStock })
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  isAllowNegativeStock = (): boolean => {
    const { selectedProduct } = this.state
    if (!selectedProduct) {
      return false
    }
    return selectedProduct.v[0].allow_negative_stock || false
  }

  _doEditProduct = async (editKey: string, editValue: any): Promise<boolean> => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { selectedProduct } = this.state
    // const { editProduct } = this.props
    try {
      const ppToEdit = { pp_id: selectedProduct.v[0].i }
      ppToEdit[editKey] = editValue

      const res = await api.editProductBatch({
        store_id: util.getNavParam(this.props, 'store_id'),
        products: [ppToEdit],
      })

      if (res && res.success) {
        this.inProcess = false
        return true
      }

      //   const variantAction = {
      //     action: 'EDIT',
      //     pp_id: selectedProduct.v[0].i,
      //   }

      //   variantAction[editKey] = editValue

      //   const store_id = util.getNavParam(this.props, 'store_id')
      //   const body = {
      //     store_id,
      //     product_id: selectedProduct.id,
      //     variants: [variantAction],
      //   }

      //   const response: IEditProductResponse | null = await new Promise((resolveEdit) => {
      //     editProduct({
      //       body,
      //       successCallback: resolveEdit,
      //       failedCallback: () => resolveEdit(null),
      //     })
      //   })
      //   console.log('response', response)
    } catch (error) {
      console.log('error', error)
    }

    this.inProcess = false
    return false
  }

  _onChangeIsAllowNegativeStock = async (newValue: boolean) => {
    const { selectedProduct, isSubmitting } = this.state
    if (isSubmitting) {
      return
    }
    await util.setStatePromise(this, { isSubmitting: true })

    const isSuccess = await this._doEditProduct('allow_negative_stock', newValue)
    // if (!isSuccess) {
    //   // p.op.showToast('เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง', 'danger')
    //   return
    // }

    const newState: Partial<IProductVariantSettingState> = {}
    if (isSuccess) {
      const updatedProduct = _.cloneDeep(selectedProduct)
      updatedProduct.v[0].allow_negative_stock = newValue
      // await util.setStatePromise(this, { selectedProduct: updatedProduct })
      newState.selectedProduct = updatedProduct

      const onSuccessEdit = util.getNavParam(this.props, 'onSuccessEdit')
      if (onSuccessEdit) {
        onSuccessEdit(updatedProduct)
      }

      // await util.delay(1500) // wait for UX
      // await util.setStatePromise(this, { isAllowNegativeStock: newValue })
      // await util.delay(2500) // wait for UX
    }

    // await util.setStatePromise(this, { isSubmitting: false, isAllowNegativeStock: isSuccess ? newValue : !newValue })
    newState.isSubmitting = false
    newState.isAllowNegativeStock = isSuccess ? newValue : !newValue
    await util.setStatePromise(this, newState)
  }

  _handlePressProductID = (ppId: number) => {
    if (p.op.isWeb()) {
      Clipboard.setString(ppId.toString())
      p.op.showToast(`คัดลอกรหัสสินค้า ID:${ppId} ไปยังคลิปบอร์ดแล้ว`, 'success')
    }
  }

  _renderSelectedProductVariant = () => {
    const { selectedProduct } = this.state
    if (!selectedProduct) {
      return null
    }

    const spv = selectedProduct.v[0]
    const pName = selectedProduct.n
    const hasProductName = pName && pName.length > 0
    let thumbnailUri = spv.img_url
    if (!thumbnailUri) {
      thumbnailUri = selectedProduct?.t[0]
    }
    const hasProductVariantName = spv.n && spv.n.length > 0

    return (
      <HStack w='full' px='2' py='1' alignItems='center' justifyContent='center'>
        <ProductBundleContainer productBundleItem={spv} renderRightHeader={() => null}>
          <VStack w='full' py='1.5' px='2' space='1' bg='white'>
            <HStack w='full' space='1.5'>
              <VStack w='16' h='16'>
                <XImage w='16' h='16' borderRadius='lg' resizeMode='cover' source={{ uri: thumbnailUri }} />

                <Box position='absolute' top='1' left='1'>
                  <XSellyLogo width={24} height={24} />
                </Box>
              </VStack>

              <VStack flex={1}>
                <HStack w='full'>
                  <VStack flex={1}>
                    <XText w='full' numberOfLines={2}>
                      {hasProductName ? pName : '(ยังไม่มีชื่อสินค้า)'}
                    </XText>
                    {spv.sku && spv.sku !== '' ? (
                      <XText w='full' variant='inactive' numberOfLines={1}>
                        {`SKU: ${spv.sku}`}
                      </XText>
                    ) : null}
                    {spv.upc && spv.upc !== '' ? (
                      <XText w='full' variant='inactive' numberOfLines={1}>
                        {`UPC: ${spv.upc}`}
                      </XText>
                    ) : null}
                  </VStack>
                  <VStack w='100px' alignItems='flex-end'>
                    <XText w='full' textAlign='right' bold numberOfLines={3}>
                      {/* {hasProductVariantName ? spv.pp_name : '(ยังไม่มีชื่อตัวเลือกสินค้า)'} */}
                      {hasProductVariantName ? spv.n : ''}
                    </XText>
                  </VStack>
                </HStack>
              </VStack>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText fontSize='xs' variant='inactive' onPress={() => this._handlePressProductID(spv.i)}>{`ID:${spv.i}`}</XText>
            </HStack>
          </VStack>
        </ProductBundleContainer>
      </HStack>
    )
  }

  // _renderWarningAllowNegativeStock = () => {
  //   const isStoreAllowNegativeStock = util.isStoreAllowNegativeStock()
  //   if (isStoreAllowNegativeStock) {
  //     return null
  //   }

  //   return (
  //     <VStack w='full'>
  //       <VStack w='full' alignItems='center' bg='yellow.100' borderRadius='lg' p='2'>
  //         <XText color='yellow.800'>ฟีเจอร์สินค้าพรีออเดอร์ถูกปิดใช้งานอยู่</XText>
  //         <XText color='yellow.800'>{'กรุณาเปิดใช้งานฟีเจอร์พรีออเดอร์ ในหน้า ตั้งค่าร้านค้า > พรีออเดอร์'}</XText>
  //       </VStack>
  //     </VStack>
  //   )
  // }

  _renderAllowNegativeStockSetting = () => {
    const { selectedProduct, isSubmitting, isAllowNegativeStock } = this.state
    const parentPtId = selectedProduct?.s
    const isPulledProduct = _.isNumber(parentPtId) && parentPtId > 0

    const isStoreAllowNegativeStock = util.isStoreAllowNegativeStock()
    const isStoreAllowNegativeStockAllProducts = util.isStoreAllowNegativeStockAllProducts()

    const isSwitchDisabled = isPulledProduct || isSubmitting || !isStoreAllowNegativeStock

    return (
      <VStack px='4' py='2' w='full' bg={isPulledProduct || !isStoreAllowNegativeStock ? 'gray.100' : 'white'}>
        <HStack w='full' space='2'>
          <VStack flex={1}>
            <HStack alignItems='center' space='1'>
              <XIcon name='cart-arrow-right' family='MaterialCommunityIcons' color='amber.600' />
              <XText variant='active' fontSize='md'>
                อนุญาตให้ พรีออเดอร์ ได้
              </XText>
            </HStack>

            <XText variant='inactive'>
              พรีออเดอร์ หรือ <XText bold>"สั่งเกินจำนวนพร้อมขายได้"</XText> คือการอนุญาตให้สามารถเปิดออเดอร์ได้แม้ จำนวน
              <XText bold>"พร้อมขาย"</XText> ของสินค้ามีน้อยกว่าจำนวนสินค้าที่ระบุขณะสร้างออเดอร์
            </XText>
          </VStack>

          <HStack w='80px' h='34px' justifyContent='flex-end' alignItems='center' space='1'>
            {isSubmitting ? <XSpinner size='sm' /> : null}
            {isStoreAllowNegativeStock && isStoreAllowNegativeStockAllProducts && !isPulledProduct ? (
              <XText variant='success' bold>
                อนุญาติ
              </XText>
            ) : (
              <XSwitch disabled={isSwitchDisabled} value={this.isAllowNegativeStock()} onValueChange={this._onChangeIsAllowNegativeStock} />
            )}
          </HStack>
        </HStack>

        {isPulledProduct ? (
          <VStack w='full' alignItems='center' bg='yellow.100' borderRadius='lg' p='2'>
            <XText variant='inactive' color='gray.500'>
              ไม่สามารถแก้ไขการตั้งค่าสินค้าพรีออเดอร์ได้ เนื่องจากสินค้านี้เป็นสินค้าจากร้านอื่น
            </XText>
          </VStack>
        ) : null}

        {!isStoreAllowNegativeStock && (
          <VStack w='full'>
            <VStack w='full' alignItems='center' bg='yellow.100' borderRadius='lg' p='2'>
              <XText color='yellow.800'>ฟีเจอร์สินค้าพรีออเดอร์ถูกปิดใช้งานอยู่</XText>
              <XText color='yellow.800'>{'กรุณาเปิดใช้งานฟีเจอร์พรีออเดอร์ ในหน้า ตั้งค่าร้านค้า > พรีออเดอร์'}</XText>
            </VStack>
          </VStack>
        )}
        {/* {this._renderWarningAllowNegativeStock()} */}
      </VStack>
    )
  }

  _renderContent = () => {
    const { isInitialized, selectedProduct, isSubmitting, isAllowNegativeStock } = this.state
    if (!isInitialized) {
      return (
        <VStack flex={1} justifyContent='center' alignItems='center'>
          <XSpinner size='lg' />
        </VStack>
      )
    }

    return (
      <VStack w='full' px='2' py='3' space='1.5' bg='white'>
        {this._renderSelectedProductVariant()}

        {this._renderAllowNegativeStockSetting()}
        {/* <VStack mt='2'>
          <XButton onPress={() => this._doEditProduct('weight', 1)}>Test Edit Weight to 1</XButton>
        </VStack> */}
      </VStack>
    )
  }

  render() {
    // const { isInitialized } = this.state
    // if (!isInitialized) {
    //   return null
    // }

    // const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    return (
      <XContainer>
        <XCustomHeader title='ตั้งค่าสินค้า' headerLeftProps={{ backIcon: true, onPressItem: this._goBack }} />
        <XContent>
          {/*  */}
          {this._renderContent()}
        </XContent>
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    // selectedProduct: getSelectedProduct(state),
    // mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => ({
    editProduct: bindActionCreators(ProductActions.editProduct, dispatch),
    dispatch,
  })
)(ProductVariantSettingView)
